import type { GoalInfo, Hit } from '@boss/shared'
import { PrizeName } from './PrizeName'

/** Every name is shown wallet-style, first and last four characters, so rows never overflow. */
function shortRef(ref: string | null) {
  if (!ref) return 'someone'
  return ref.length > 9 ? `${ref.slice(0, 4)}…${ref.slice(-4)}` : ref
}

export function Feed({ hits, goals }: { hits: Hit[]; goals: GoalInfo[] }) {
  const goal = (id: string) => goals.find((g) => g.id === id)
  return (
    <aside className="feed" aria-label="Recent hits">
      <h2 className="feed-title">Recent attacks</h2>
      {hits.length === 0 ? (
        <p className="feed-empty">Waiting for packs to be opened…</p>
      ) : (
        <ol className="feed-list">
          {hits.map((h) => {
            const g = goal(h.goalId)
            const completed = g ? h.pointsAfter >= g.target && h.pointsAfter - h.points < g.target : false
            const final = h.progressAfter >= 1
            const kind = h.superEffective && h.crit ? 'both' : h.superEffective ? 'super' : h.crit ? 'crit' : null
            const bonus = kind === 'both' ? "A critical hit! It's super effective!" : kind === 'super' ? "It's super effective!" : kind === 'crit' ? 'A critical hit!' : null
            return (
              <li key={h.seq} className={`${final || completed ? 'ko' : ''}${kind ? ` bonus ${kind}` : ''}`}>
                <span className="feed-user">
                  <span className="feed-name">{shortRef(h.userRef)}</span>
                  <span className="feed-points">×{h.points}</span>
                  {bonus ? <span className="feed-bonus">{bonus}</span> : null}
                </span>
                <span className="feed-what" title={h.detail ?? undefined}>
                  opened a <em className="pack" style={g?.color ? { color: g.color } : undefined}>{g?.label ?? h.packCode}</em>
                  {h.detail ? (
                    <>
                      {' '}
                      and pulled <PrizeName name={h.detail} image={h.image} />
                    </>
                  ) : null}
                  {final ? ' — the final blow!' : completed ? ' — goal reached!' : ''}
                </span>
              </li>
            )
          })}
        </ol>
      )}
    </aside>
  )
}
